// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__P-raa","title":"FrontImage_title__3Stt_"};